import React from 'react';
import './navigation.css';
import { Link } from 'react-router-dom'; 

export default  function Navigation() { 
    const [navLinkHover1, showNavLinkHover1] = React.useState(false)   
    const [navLinkHover2, showNavLinkHover2] = React.useState(false)   
    const [navLinkHover3, showNavLinkHover3] = React.useState(false)   

    const [isNavActive, showNav] = React.useState(false)  
    const toggleNav = () => {
        showNav(!isNavActive)
        !isNavActive 
            ?   document.body.style.overflow = "hidden"
            :   document.body.style.overflow = "visible"
    };

    return (
        <header>
            <nav className="header-nav" >
                <ul className="header-nav-ul" > 
                    <li className="header-nav-ul-li" > 
                        <Link to="/">MOHAMED</Link>
                    </li>  
                </ul>

                <button className={isNavActive ? "burger-clicked": "burger"} onClick={toggleNav}>
                    <section className="strip burger-strip">
                        <div></div>
                        <div></div>
                    </section>
                </button>
                <menu className={!isNavActive 
                        ? "hidden-menu"
                        : "display-menu"
                    }> 
                    <article className="menu-wrapper">
                        <ul className="menu-wrapper-redirect">
                            <li  className={"menu-redirect-content"}> 
                                <Link to="/about" onClick={toggleNav}>
                                    ABOUT
                                </Link>
                            </li>
                            <li  className={"menu-redirect-content"}> 
                                <Link to="/contact" onClick={toggleNav}>
                                    CONTACT
                                </Link>
                            </li>
                        </ul>

                        <section className={"menu-wrapper-links-container"}>

                            <a 
                                onMouseEnter={() => showNavLinkHover2(true)}
                                onMouseLeave={() => showNavLinkHover2(false)} 
                                className={  
                                    navLinkHover2 ? "links-container-link-idel" : 
                                    (!navLinkHover1 && !navLinkHover2 && !navLinkHover3) 
                                    ? "links-container-link-hover" : "links-container-link-not-hover"
                                } href={"https://github.com/MohamedBakoush"} rel="noreferrer" target="_blank">  
                                GITH
                            </a> 
        
                            <div className={"links-container-line"}/>

                            <a
                                onMouseEnter={() => showNavLinkHover3(true)}
                                onMouseLeave={() => showNavLinkHover3(false)} 
                                className={  
                                    navLinkHover3 ? "links-container-link-idel" : 
                                    (!navLinkHover1 && !navLinkHover2 && !navLinkHover3) 
                                    ? "links-container-link-hover" : "links-container-link-not-hover"
                                } href={"https://www.linkedin.com/in/mohamed-bakoush/"} rel="noreferrer" target="_blank">  
                                LINK
                            </a> 
                        </section>

                    </article>
                </menu>
            </nav> 
        </header>
    );
}
 